import { format } from 'date-fns'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/en.js'
import 'dayjs/locale/ko.js'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)
dayjs.locale('en')

const getCurrentLocale = () => {
  try {
    const savedLang = localStorage.getItem('app_language')
    if (savedLang === 'ko-KR') return 'ko'
    return 'en'
  } catch {
    return 'en'
  }
}

export const formatDate = (date: Date): any => {
  return format(new Date(date), `dd/MM/yyyy HH:mm:ss`)
}

export const formatDateDay = (date: any): any => {
  const dates = new Date(date)
  return format(dates, 'MM yyyy')
}

export const getMinites = (millis: number = 0) => {
  return Math.floor(millis / 60000) % 60
}

export const getHours = (millis: number = 0) => {
  return Math.floor(millis / 3600000)
}

export function timeStringToMillisecond(str: string) {
  try {
    const timeArr = str.split(':').map((val) => +val)
    const date = (timeArr[0] * 3600 + timeArr[1] * 60 + timeArr[2]) * 1000
    return date
  } catch {
    return 0
  }
}

export function getTimeFromGMTOffset(gmtString: string, format = 'hh:mm A') {
  if (!gmtString) {
    return ''
  }
  const match = gmtString.match(/GMT([+-]\d{1,2}):(\d{2})/)
  if (!match) return 'Invalid GMT format'

  const hours = parseInt(match[1], 10)
  const minutes = parseInt(match[2], 10)

  return dayjs
    .utc()
    .add(hours, 'hour')
    .add(minutes, 'minute')
    .locale(getCurrentLocale())
    .format(format)
}

export function getTimeFromGMTandTimestamp(
  gmtString: string,
  timestamp: number,
  format = 'DD MMM YYYY hh:mmA',
) {
  if (!gmtString) {
    return ''
  }
  const match = gmtString.match(/GMT([+-]\d{1,2}):(\d{2})/)
  if (!match) return 'Invalid GMT format'

  const hours = parseInt(match[1], 10)
  const minutes = parseInt(match[2], 10)

  return dayjs
    .utc(timestamp)
    .add(hours, 'hour')
    .add(minutes, 'minute')
    .format(format)
}

export function calculateIsAvg(
  startDate: string,
  endDate: string,
  thresholdDays = 29,
): boolean {
  const date1 = new Date(startDate)
  const date2 = new Date(endDate)
  const diffTime = Math.abs(date2.getTime() - date1.getTime())
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  return diffDays >= thresholdDays
}

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))

export const formatDateByTimeZone = (
  date: string | Date,
  timezone: string,
  format: string,
) => {
  return dayjs.utc(date).tz(timezone).format(format)
}

export const convertFormatDateByTimeZone = (
  inputTime: string,
  timezone: string,
  formatFrom: string,
  formatTo: string,
) => {
  return dayjs.tz(inputTime, formatFrom, timezone).format(formatTo)
}
